<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      clipped
      fixed
      app
    >
      <SideBar></SideBar>
    </v-navigation-drawer>

    <v-toolbar app fixed clipped-left class="green darken-2 white--text">    
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="white--text" ></v-toolbar-side-icon>
      <v-toolbar-title v-text="title" class="white--text"></v-toolbar-title>   
      <v-spacer></v-spacer>
      <header-bar></header-bar>
    </v-toolbar>

    <v-content>
        <v-container fluid>
            <router-view></router-view>
        </v-container>
    </v-content>

    <v-footer app fixed class="white--text" style="background:#469855">     
      <span justify-center align-center style="margin-left:15px;">MIS & Accounting Software &copy; {{year}}</span>
      <v-spacer></v-spacer>      
       <span justify-center align-center style="margin-right:15px; text-align:right">IBCS-PRIMAX Software (Bangladesh) Ltd.</span>
    </v-footer>

  </v-app>
</template>

<script>
  import HeaderBar from '../components/header.vue'
    import SideBar from '../components/sidebar.vue'

    export default {
        components: {HeaderBar, SideBar},
    data: () => ({
      drawer: null
    }),
    props: {
      source: String
    },
    computed: {
        year(){
         var d = new Date();
         return d.getFullYear();          
        },

        title() {
          let proInfo = this.$store.getters.GET_PROJECT_INFO;
          let moduleTitle = this.$store.getters.GET_MODULE_NAME;
          return (
            "MIS & Accounting Software for " +
            proInfo.project_name_short +
            " (" +
            moduleTitle +
            " Module)"
            );
      },
  }
  };
</script>

<style scope>
.green.darken-2 {
    background-color: #388E43 !important;
    border-color: #388E43 !important;
    opacity: 0.9;
}  
.footer{
    position: fixed;
    bottom: 30px;
}
</style>


// WEBPACK FOOTER //
// src/layouts/portalLayout.vue